<template>
  <div class="user-list-container">
   <rich-txt
   v-if="form.content"
            :modelValue="form.content"
            @change="
              (val) => {
                form.content = val;
              }
            "
          ></rich-txt>
          <div style="display: flex;align-items: center;">
            <el-button type="primary" @click="save" style="margin: 60px auto;">保存</el-button>
          </div>
  </div>
</template>

<script>
import api from "@/request/api.js";
import upload from "@/components/upload.vue";
import tableMixin from "@/mixins/tableMixin";
import richTxt from "@/components/richheight.vue";
export default {
  name: "UserList",
  components: { upload, richTxt },
  data() {

    return {
      form: {
      },
    }
  },
  mounted() {
    api.Gonggao.getDeatil().then((res) => {
      this.form = res.data;
    }).catch((err) => {
      console.error("获取公告详情失败:", err);
    });
  },
  methods: {
    async save() {
      try {
        await api.Gonggao.setGonggao(this.form);
        this.$message.success("保存成功");
      } catch (error) {
        this.$message.error("保存失败");
        console.error("保存公告失败:", error);
      }}
  },
};
</script>

<style scoped>
.user-list-container {
  padding: 20px;
}
.search-card {
  margin-bottom: 20px;
}
.table-card {
  margin-bottom: 20px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
